const UsersMenuTypes = {
    USERS: {
        id: "users",
        group: "UserSettings",
        path: "/users",
        label: "Users",
        tabs: [],
        implemented: true,
    },
    ROLES: {
        id: "roles",
        group: "UserSettings",
        path: "/roles",
        label: "Roles",
        tabs: [],
        implemented: true,
    },
    DEPARTMENTS: {
        id: "departments",
        group: "UserSettings",
        path: "/departments",
        label: "Departments",
        tabs: [],
        implemented: true,
    },
    BANNED_VISITORS: {
        id: "bannedVisitors",
        group: "UserSettings",
        path: "/banned-visitors",
        label: "Banned Visitors",
        tabs: [],
        implemented: true, // if you show item in menu set to true
    },
};

Object.keys(UsersMenuTypes).forEach((key) => {
    if (!UsersMenuTypes[key].implemented) {
        delete UsersMenuTypes[key];
    }
});

export default UsersMenuTypes;
